export default __webpack_public_path__ + "static/media/Snd_Try8.dfb3d657.mp3";